const getBaseUrlPath = () => {
    const baseElement = document.head.querySelector('base');
    if (baseElement === null) {
        throw new Error('Base element not found');
    }
    return new URL(baseElement.href).pathname;
};
const BASE_PATH = getBaseUrlPath();
export const buildUrlPath = (path) => {
    return `${BASE_PATH}${path}`.replace(/\/\/+/g, '/');
};
